// extracted by mini-css-extract-plugin
export default {"App":"_About_App__i-Skg","about_page":"_About_about_page__0IW6k"};